import types, { ActionCreators } from './types';

const getStartedUpdate: ActionCreators['GetStartedUpdate'] = (key, value) => ({
  type: types.GET_STARTED_UPDATE,
  key,
  value,
});

const requestGetStartedDataOK: ActionCreators['RequestGetStartedOK'] = (getStartedMetaData) => ({
  type: types.REQUEST_GET_STARTED_OK,
  ...getStartedMetaData,
});

const resetInitialGetStartedState: ActionCreators['ResetInitialGetStartedState'] = (
  getStartedMetaData,
) => ({
  type: types.RESET_INITIAL_GET_STARTED_STATE,
  getStartedMetaData,
});

const updateGetStarted: ActionCreators['UpdateGetStarted'] = () => ({
  type: types.UPDATE_GET_STARTED,
});

const updateGetStartedERR: ActionCreators['UpdateGetStartedERR'] = (errorMessages, error) => ({
  type: types.UPDATE_GET_STARTED_ERR,
  errorMessages,
  error,
});

const updateGetStartedOK: ActionCreators['UpdateGetStartedOK'] = () => ({
  type: types.UPDATE_GET_STARTED_OK,
});

const actions = {
  getStartedUpdate,
  requestGetStartedDataOK,
  resetInitialGetStartedState,
  updateGetStarted,
  updateGetStartedERR,
  updateGetStartedOK,
};

export default actions;
